import React from "react";
import icon1 from "../../../assets/images/icons/2.png";
import icon2 from "../../../assets/images/icons/3.png";
import icon3 from "../../../assets/images/icons/4.png";

const SalesContactInfo = () => (
  <div className="bg-black p-3 my-4 br_7 w-100">
    <div className="contactUsDetailBox">
      <ContactBox
        icon={icon1}
        label="Address"
        content="Unit No.III A-2, 3rd Floor, Phase II, Carnival Infopark, Kusumagiri, Kakkanad, Kochi -
682 042, Kerala"
      />
      <ContactBox
        icon={icon2}
        label="Email"
        content={
          <a
            href="mailto:connect@pixl.ai"
            className="font_14 text-white mb-0 line_height1_7 text-decoration-none"
          >
            connect@pixl.ai
          </a>
        }
      />
      <ContactBox
        icon={icon3}
        label="Contact"
        content={
          <a
            href="tel:+917994433594"
            className="font_14 text-white mb-0 line_height1_7 text-decoration-none"
          >
            +917994433594
          </a>
        }
      />
    </div>
  </div>
);

const ContactBox = ({ icon, label, content }) => (
  <div className="">
    <div className="contactUsBox d-flex justify-content-end flex-column p-3 br_7">
      <div className="d-flex align-items-center gap-1 mb-1">
        <img src={icon} alt={label} />
        <h5 className="font_13 font_400 text_light7 mb-0">{label}</h5>
      </div>
      <p className="font_14 text-white mb-0 line_height1_7">{content}</p>
    </div>
  </div>
);

export default SalesContactInfo;
